import z from 'zod';
import { customEventBaseFields, kebabString, primitive } from './base-fields';

const sortDirection = ['asc', 'desc'] as const;

const itemList = {
  type: kebabString,
  count: z.number().int().optional(),
  pageSize: z.number().int().optional(),
  pageNumber: z.number().int().optional(),
  displayMode: kebabString.optional(),
  order: z
    .object({
      field: kebabString.optional(),
      direction: z.enum(sortDirection).optional(),
    })
    .optional(),
  ...customEventBaseFields,
};

export default {
  filtered: z.object({
    ...itemList,
    searchTerm: z.string().optional(),
    facets: z
      .record(z.array(primitive.transform(v => String(v))))
      .transform(input => JSON.stringify(input))
      .optional(),
  }),
  displayed: z.object(itemList),
  ordered: z.object({
    ...itemList,
    parentId: z.string().optional(),
    parentDescription: z.string().optional(),
    items: z
      .array(
        z.object({
          id: z.string(),
          description: z.string().optional(),
          sequence: z.number().optional(),
        }),
      )
      .optional(),
  }),
};
